function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html } from "@custom/schema";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useRef, useState } from "react";
export default function AccordionItem(param) {
    var title = param.title, markup = param.markup;
    var contentRef = useRef(null);
    var _useState = _sliced_to_array(useState("0px"), 2), height = _useState[0], setHeight = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isOpen = _useState1[0], setIsOpen = _useState1[1];
    useEffect(function() {
        if (contentRef.current) {
            var scrollHeight = contentRef.current.scrollHeight;
            setHeight(isOpen ? "".concat(scrollHeight, "px") : "0px");
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        role: "button",
        "aria-expanded": isOpen,
        className: "text-left flex justify-between w-full py-6 focus focus:outline-offset-0 hover:text-blue-500 transition-all"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-lg lg:text-xl pr-4 md:pr-8"
    }, title), /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: "".concat(isOpen ? "rotate-180" : "", " w-6 h-6 shrink-0")
    })), /*#__PURE__*/ React.createElement("div", {
        ref: contentRef,
        className: "overflow-hidden transition-all",
        style: {
            maxHeight: height
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pb-5 prose content-text"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: markup
    }))));
}
